<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <page-snippet class="mt-2 mb-2" v-if="true" name="add-contributor" />
        <label for="text-search">{{ $t('Search') }}</label>
        <b-form-input ref="search-input" id="text-search" :value="searchQuery" @input="searchQueryChange"></b-form-input>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="mt-3 mb-3">
        <p>
          {{ $t('If you are unable to find the contributor you are looking for, you can') }}
          <a href="#" :disabled="searching" @click.prevent="createNew">{{ $t('create a new Contributor') }}</a>
        </p>
        <b-button :disabled="searching" variant="light" v-on:click.prevent="cancel">{{ $t('Close') }}</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h4 v-if="showCurrentContributors && contributorList.length > 0">{{ $t('Add role to current contributors') }}:</h4>
        <h4 v-if="searching">{{ $t('Search results') }}: <b-spinner small v-if="searching" label="Spinning" /></h4>

        <span v-if="results && results.length == 0 && !searching">{{ $t('No results') }}</span>
        <b-table-simple v-if="contributorList">
          <b-tbody>
            <b-tr v-for="(item, index) in contributorList" :key="index">
              <b-td width="0">
                <b-img 
                  :srcset="item.ImageSrcSet" 
                  @load="item.LoadedImage = true" 
                  v-show="item.LoadedImage" 
                  style="max-width: 150px;"
                />{{ }}
              </b-td>
              <b-td width="50%">
                <strong>{{ item.NameFull }}</strong><br />
                <p
                  class="text-danger font-weight-bold m-0" 
                  v-if="item.ProtectionStatus && item.ProtectionStatus.BlockForDelivery"
                >
                  {{ item.ProtectionStatus.PortalDescription }}
                </p>
                
                <template v-if="item.SpotifyData">
                  {{ $t('Followers') }}: {{ item.SpotifyData.followers.total }}<br>
                  {{ $t('Popularity') }}: {{ item.SpotifyData.popularity }}<br>
                  <template v-if="item.SpotifyData.genres.length > 0">Genres: {{ item.SpotifyData.genres.join(', ') }}<br></template>
                </template>
                
                <template v-for="(outletId, outletName) in item.Identifiers">
                  <a v-if="outletName == 'Spotify'" :key="outletName + 'spotify'" :href="spotifyUrl(item)" target="_blank">
                    <img :alt="outletName" src="@/assets/images/spotify-logo-green.png" width="25" class="mr-2 mt-2" style=" vertical-align: baseline" />
                  </a>
                  <img :alt="outletName" :key="outletName + 'meta'" v-if="outletName == 'Meta'" src="@/assets/images/meta-icon.svg" width="30" class="m3-2 mt-2" style=" vertical-align: baseline" />
                  <img :alt="outletName" :key="outletName + 'thso'" v-if="outletName == 'THSO'" src="@/assets/images/thso-icon.png" height="30" class="mr-2 mt-2" style="vertical-align: baseline" />
                  <a :key="outletName + 'iTunes'" v-if="outletName == 'iTunes'" :href="'https://music.apple.com/artist/' + outletId" target="_blank">
                    <img :alt="outletName" src="@/assets/images/apple-music-icon.svg" width="25" class="mr-2 mt-2" style=" vertical-align: baseline" />
                  </a>
                </template>

                <div class="mt-2" v-if="currentContributors[item.ContributorKey] && currentContributors[item.ContributorKey].Roles">
                  {{ $t('Current Roles') }}
                  <ul class="inline-comma-list font-weight-bold">
                    <li v-for="(role, index) in currentContributors[item.ContributorKey].Roles" :key="index">
                      {{ role }}
                    </li>
                  </ul>
                </div>
              </b-td>
              <b-td width="50%">
                <template>
                  <b-button class="mr-1 mb-1" small v-for="(role, index) in highlightedRoles(item)" :key="index" @click="add(item, role.value)">
                    {{ $t('Select as') }} {{ $t(role.text) }}
                  </b-button>
                </template>
                <br>

                <label class="mt-2" for="text-search">{{ $t('Other roles') }}: {{  }}</label>
                <b-input-group>
                  <b-form-select :ref="'role-select-'+index" :options="removeSelectedRoles(item, roles)" v-model="selectValues[index]"></b-form-select>
                  <b-input-group-append>
                    <b-button v-on:click.prevent="add(item, $refs['role-select-'+index][0].value)">{{ $t('Add') }}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  // TODO: Roles are a different structure in searchresult from this.roles. Needs more elegant solution

  import { 
    genContributorKey, genContributorNameFull, 
    contribKeyToIdentifiers } from '../functions'

  import { debounce } from 'lodash';
  import axios from "axios"

  export default {
    name: 'ContributorSearch',
    components: {
      'page-snippet': () => import('@/components/PageSnippet'),
    },
    data () {
      return {
        showCurrentContributors: true,
        searching: false,
        results: null,        
        selectValues: {},
        searchQuery: '',
      }
    },
    props: {
      'provider-id': String,
      'sub-provider-id': String,
      'role-defs': Object,
      'type': String,
      'current-contributors': { type: Object, default: () => { return {} } },
      'visible': Boolean
    },
    watch: {
      visible (value) {
        if (value) this.$refs['search-input'].$el.focus()
      },
    },
    methods: {
      test ($event, item) {
        console.log($event.target)
        item.LoadedImage = true
      },
      searchQueryChange (query) {
        query = query.trim()
        if (this.searchQuery == query) return
        this.searchQuery = query
        this.asyncFind(query)
      },
      async add (item, role) {
        // Check if contributor exists, if not, create
        if (!item.Identifiers.THSO) {
          if (this.creatingContributor == true) {
            this.$notify({
              type: 'warn',
              text: this.$t('Adding contributor in progress, please wait'),
            })
            return
          }
          this.creatingContributor = true
          
          if (!item.Identifiers.Spotify) throw new Error('Spotify ID missing')

          let toCreate = {}

          // Clean data
          for (const [key, value] of Object.entries(JSON.parse(JSON.stringify(item)))) {
            if (!value) continue
            if (![
                    'NamePart1', 
                    'NamePart2',
                    'NamePart3',
                    'Identifiers',
                  ].includes(key)) continue

            toCreate[key] = value
          }

          let response
          try {
            response = await this.$http.post('contributors', toCreate )
            item.ContributorID = response.data.ContributorID
            item.Identifiers = response.data.Identifiers
          } catch (error) {
            console.log('Error', error)
            this.$notify({
              type: 'warn',
              text: this.$t('Something went wrong while creating Contributor, please try again.'),
            })
            this.creatingContributor = false
            return
          }

          this.creatingContributor = false
        }

        this.$emit('add', item, role)
      },
      spotifyUrl (item) {
        try {
          return item.SpotifyData.external_urls.spotify
        } catch  {
          return '#'
        }
      },
      imgSrcSet (item) {
        if (item.SpotifyData && item.SpotifyData.images) {
          return item.SpotifyData.images.map(i => { return i.url + ' ' + i.width + 'w' }).join(',')
        } else if (item.Identifiers) {
          const oi = item.Identifiers
          
          if (oi.Spotify) {
            const split = oi.Spotify.split(':')
            if (split.length == 3)
              return '/api/asset/image-artist-spotify-' + split[2]
          }

          if (oi.THSO) {
            return '/api/asset/image-artist-thso-' + oi.THSO
          }
        }
        return
      },
      asyncFind: debounce(function (query) {
        this.showCurrentContributors = false

        if (this.cancelToken) {
          this.cancelToken.cancel()
          this.cancelToken = null
        }

        if (query == '') {
          this.results = ''
          this.searching = false;
          return
        }

        this.cancelToken = axios.CancelToken.source()

        this.searching = true
        this.$http.get('contributors/search', {
          params: { 
            productType: this.type,
            providerId: this.providerId,
            subProviderId: this.subProviderId,
            q: this.searchQuery
          }
        }, {
          cancelToken: this.cancelToken.token
        }).then(response => {
          this.results = response.data.slice(0, 40).map(c => {
            const map = {
              OutletIdentifiers: 'Identifiers',
              Name1: 'NamePart1',
              Name2: 'NamePart2',
              Name3: 'NamePart3',
            }
            for (const [key, newKey] of Object.entries(map)) {
              if (!(key in c)) continue
              c[newKey] = c[key]
              delete c[key]
            }

            c.ContributorKey = genContributorKey(c)
            c.ImageSrcSet = this.imgSrcSet(c)
            c.LoadedImage = false
            return c
          })
        }).catch((e) => {
          this.$notify({
            type: 'warn',
            text: this.$t('Something went wrong while searching, please try again.'),
          })
          console.log(e)
          this.results = []
        }).finally(() => {
          this.searching = false
        })
      }, 100),
      cancel () {
        this.$emit('done', 'cancel')
      },
      createNew () {
        this.$emit('done', 'createNew')
      },
      removeSelectedRoles(item, roles) {
        return roles.filter(r => {
          let c = this.currentContributors[item.ContributorKey]
          if (!c || !c.Roles) return true
          return !c.Roles.includes(r.value || r.Description)
        })
      },
      highlightedRoles (item) {
        let roles = [];
        if (item.Roles) {
          roles = item.Roles.map(role => { 
            return {
              value: role,
              text: role,
            }
          })
        }
        return this.removeSelectedRoles(item, this.addOtherRoles(roles)).slice(0, 4)
      },
      addOtherRoles (roles) {
        return roles.concat(this.roles.filter(a => {
          return !roles.some(b => { 
            return a.value == b.value
          })
        }))
      },
    },
    computed: {
      roles () {
        return this.roleDefs.Options.map(cr => { 
          return {
            value: cr.JsonValue,
            text: cr.Value,
          }
        })
      },
      contributorList () {
        if (!this.showCurrentContributors) return this.results
        if (!this.currentContributors) return []

        let out = []
        for (const [key, c] of Object.entries(this.currentContributors)) {
          out.push({
            ContributorKey: key,
            Identifiers: contribKeyToIdentifiers(key),
            NameFull: genContributorNameFull(c),
            Name1: c.NamePart1,
            Name2: c.NamePart2,
            Name3: c.NamePart3,
          })
        }

        return out
      },
    },
    mounted () {
      this.$nextTick(() => {
        this.$refs['search-input'].$el.focus()
      })
    }
  }
</script>
